import { useState, FormEvent } from 'react';

const FORM_URL = 'https://readdy.ai/api/form/d7b5cpu8177dosp0is50';

export default function Contact() {
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);
  const [charCount, setCharCount] = useState(0);

  const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const formData = new FormData(form);
    const params = new URLSearchParams();
    formData.forEach((value, key) => { params.append(key, value.toString()); });
    setLoading(true);
    try {
      await fetch(FORM_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: params.toString(),
      });
      setSubmitted(true);
    } catch {
      setSubmitted(true);
    } finally {
      setLoading(false);
    }
  };

  return (
    <section id="iletisim" className="py-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-start">
          {/* Left */}
          <div>
            <div className="flex items-center gap-3 mb-6">
              <div className="w-8 h-px bg-orange-500"></div>
              <span className="text-orange-500 text-xs font-bold tracking-[0.3em] uppercase">İletişim</span>
            </div>
            <h2 className="text-4xl md:text-6xl font-black text-gray-900 leading-none mb-8">
              YEDEK PARÇA
              <br />
              <span className="text-orange-500">İHTİYACINIZ</span>
              <br />
              <span className="text-transparent" style={{ WebkitTextStroke: '2px rgba(0,0,0,0.20)' }}>İÇİN</span>
            </h2>
            <p className="text-gray-500 text-base leading-relaxed mb-12">
              Uzman ekibimiz, ihtiyacınız olan yedek parçaları en kısa sürede temin etmek için hazır.
            </p>

            <div className="space-y-6">
              {[
                { icon: 'ri-phone-line', label: 'Telefon', value: '+90 536 432 25 18', sub: 'Hafta içi 08:00 - 18:00' },
                { icon: 'ri-phone-line', label: 'Telefon 2', value: '+90 531 704 35 57', sub: 'Hafta içi 08:00 - 18:00' },
                { icon: 'ri-mail-line', label: 'E-posta', value: 'info@ilkeismakinalari.com', sub: '24 saat içinde yanıt' },
                { icon: 'ri-map-pin-line', label: 'Adres', value: 'Eyüp Sultan, Cevahir Sk. No:14A, Sancaktepe/İstanbul', sub: 'Yol tarifi için tıklayın', href: 'https://www.google.com/maps/dir/?api=1&destination=Eyüp+Sultan+Cevahir+Sk+No+14A+Sancaktepe+İstanbul' },
              ].map((item) => (
                <div
                  key={item.label}
                  className={`flex items-start gap-4 group ${item.href ? 'cursor-pointer' : ''}`}
                  onClick={() => item.href && window.open(item.href, '_blank', 'noopener,noreferrer')}
                >
                  <div className="w-12 h-12 flex items-center justify-center border border-gray-200 group-hover:border-orange-500/40 rounded-sm flex-shrink-0 transition-colors duration-300 bg-white">
                    <i className={`${item.icon} text-orange-500 text-lg`}></i>
                  </div>
                  <div>
                    <div className="text-gray-400 text-xs font-bold uppercase tracking-widest mb-0.5">{item.label}</div>
                    <div className="text-gray-900 font-semibold group-hover:text-orange-500 transition-colors duration-300">{item.value}</div>
                    <div className="text-gray-400 text-xs mt-0.5">{item.sub}</div>
                  </div>
                </div>
              ))}

              <a
                href="https://wa.me/905364322518?text=Merhaba%2C%20yedek%20par%C3%A7a%20hakk%C4%B1nda%20bilgi%20almak%20istiyorum."
                target="_blank"
                rel="nofollow noreferrer"
                className="flex items-start gap-4 group cursor-pointer"
              >
                <div className="w-12 h-12 flex items-center justify-center border border-[#25D366]/30 group-hover:border-[#25D366]/60 rounded-sm flex-shrink-0 transition-colors duration-300 bg-white">
                  <i className="ri-whatsapp-line text-[#25D366] text-lg"></i>
                </div>
                <div>
                  <div className="text-gray-400 text-xs font-bold uppercase tracking-widest mb-0.5">WhatsApp</div>
                  <div className="text-gray-900 font-semibold group-hover:text-[#25D366] transition-colors duration-300">+90 536 432 25 18</div>
                  <div className="text-gray-400 text-xs mt-0.5">Hızlı parça sorgulama</div>
                </div>
              </a>
            </div>
          </div>

          {/* Right: Form */}
          <div className="bg-white border border-gray-200 p-8 md:p-10">
            {submitted ? (
              <div className="flex flex-col items-center justify-center py-16 text-center">
                <div className="w-16 h-16 flex items-center justify-center border border-orange-500/40 rounded-sm mb-6">
                  <i className="ri-check-line text-orange-500 text-3xl"></i>
                </div>
                <h3 className="text-xl font-black text-gray-900 mb-2 uppercase tracking-wider">Mesajınız İletildi!</h3>
                <p className="text-gray-500 text-sm">En kısa sürede sizinle iletişime geçeceğiz.</p>
              </div>
            ) : (
              <>
                <div className="flex items-center gap-3 mb-8">
                  <div className="w-6 h-px bg-orange-500"></div>
                  <h3 className="text-gray-900 font-black text-lg uppercase tracking-wider">Teklif / Bilgi Formu</h3>
                </div>
                <form data-readdy-form id="contact-form" onSubmit={handleSubmit} className="space-y-5">
                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                    <div>
                      <label className="block text-xs font-bold text-gray-500 uppercase tracking-widest mb-2">Ad Soyad *</label>
                      <input type="text" name="fullName" required placeholder="Adınız Soyadınız"
                        className="w-full bg-gray-50 border border-gray-200 focus:border-orange-500/50 rounded-sm px-4 py-3 text-sm text-gray-900 placeholder-gray-400 focus:outline-none transition-colors" />
                    </div>
                    <div>
                      <label className="block text-xs font-bold text-gray-500 uppercase tracking-widest mb-2">Firma Adı</label>
                      <input type="text" name="company" placeholder="Firma Adı"
                        className="w-full bg-gray-50 border border-gray-200 focus:border-orange-500/50 rounded-sm px-4 py-3 text-sm text-gray-900 placeholder-gray-400 focus:outline-none transition-colors" />
                    </div>
                  </div>
                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                    <div>
                      <label className="block text-xs font-bold text-gray-500 uppercase tracking-widest mb-2">Telefon *</label>
                      <input type="tel" name="phone" required placeholder="+90 5XX XXX XX XX"
                        className="w-full bg-gray-50 border border-gray-200 focus:border-orange-500/50 rounded-sm px-4 py-3 text-sm text-gray-900 placeholder-gray-400 focus:outline-none transition-colors" />
                    </div>
                    <div>
                      <label className="block text-xs font-bold text-gray-500 uppercase tracking-widest mb-2">E-posta</label>
                      <input type="email" name="email" placeholder="ornek@firma.com"
                        className="w-full bg-gray-50 border border-gray-200 focus:border-orange-500/50 rounded-sm px-4 py-3 text-sm text-gray-900 placeholder-gray-400 focus:outline-none transition-colors" />
                    </div>
                  </div>
                  <div>
                    <label className="block text-xs font-bold text-gray-500 uppercase tracking-widest mb-2">Makina Markası</label>
                    <select name="brand"
                      className="w-full bg-gray-50 border border-gray-200 focus:border-orange-500/50 rounded-sm px-4 py-3 text-sm text-gray-600 focus:outline-none transition-colors cursor-pointer">
                      <option value="">Marka Seçin</option>
                      <option>KOMATSU</option>
                      <option>CAT</option>
                      <option>HITACHI</option>
                      <option>VOLVO</option>
                      <option>LIEBHERR</option>
                      <option>HIDROMEK</option>
                      <option>JCB</option>
                      <option>CASE</option>
                      <option>NEW HOLLAND</option>
                      <option>HYUNDAI</option>
                      <option>DOOSAN</option>
                      <option>KUBOTA</option>
                      <option>BOBCAT</option>
                      <option>DANA</option>
                      <option>CARRARO</option>
                      <option>ZF</option>
                      <option>CUMMINS</option>
                      <option>KAWASAKI</option>
                      <option>Diğer</option>
                    </select>
                  </div>
                  <div>
                    <label className="block text-xs font-bold text-gray-500 uppercase tracking-widest mb-2">
                      Mesajınız * <span className="text-gray-400 font-normal normal-case tracking-normal">({charCount}/500)</span>
                    </label>
                    <textarea name="message" required rows={4} maxLength={500}
                      placeholder="İhtiyacınız olan parça veya hizmet hakkında bilgi verin..."
                      onChange={(e) => setCharCount(e.target.value.length)}
                      className="w-full bg-gray-50 border border-gray-200 focus:border-orange-500/50 rounded-sm px-4 py-3 text-sm text-gray-900 placeholder-gray-400 focus:outline-none transition-colors resize-none">
                    </textarea>
                  </div>
                  <button type="submit" disabled={loading}
                    className="w-full bg-orange-500 hover:bg-orange-600 disabled:bg-orange-500/40 text-white font-black py-4 rounded-sm transition-colors duration-200 flex items-center justify-center gap-3 cursor-pointer whitespace-nowrap uppercase tracking-widest text-sm">
                    {loading ? (
                      <><div className="w-5 h-5 flex items-center justify-center"><i className="ri-loader-4-line animate-spin"></i></div><span>Gönderiliyor...</span></>
                    ) : (
                      <><span>Teklif Talep Et</span><div className="w-5 h-5 flex items-center justify-center"><i className="ri-send-plane-line"></i></div></>
                    )}
                  </button>
                </form>
              </>
            )}
          </div>
        </div>
      </div>
    </section>
  );
}
